module.exports = "<h3 ng-click=\"$ctrl.i = $ctrl.i + 1\" class=color_primary style=cursor:auto>Nutzungsprotokoll</h3> <table class=\"table table-striped\" infinite-scroll=$ctrl.getNextPage() infinite-scroll-container=\"'document'\"> <thead> <tr> <th>Datum</th> <th>Meldung</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.protocol\"> <td>{{item.timestmp|date:\"dd.MM.yyyy HH:mm\"}}</td> <td>{{item.levelString}} - {{item.formattedMessage}}</td> </tr> </tbody> </table> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp-files/modules/settings/components/protocol/protocol.html
// module id = 270
// module chunks = 0